export const firebaseConfig = {
  apiKey: "AIzaSyBk80gXIlzlyG5UXBx5gLW10fEFMl3WRi0",
  authDomain: "harshita-jain.firebaseapp.com",
  projectId: "harshita-jain",
  storageBucket: "harshita-jain.appspot.com",
  messagingSenderId: "263612416845",
  appId: "1:263612416845:web:5bc9c236717ab193dfad04",
  measurementId: "G-2Y3WGK22CS"
};